module.exports = __webpack_public_path__ + "img/share-min.330d466b.png";